<template>
 <h1>stores</h1>
</template>

<script>

export default {
	name: 'stores'
}

</script>
